<script setup lang="ts">
import type {PageInterface} from "~~/server/types/page";

const SectionComponent=defineAsyncComponent(()=>import('~/components/SectionsComponent.vue'))

const { $api } = useNuxtApp()
const { locale } = useI18n()
const { data } = await useAsyncData(
    () => `page:home-page:${locale.value}`,
    () => $api<PageInterface>(`page/home-page`),
)

usePageSeo(computed(() => ({
    name: data.value?.name ?? '',
    short_description: data.value?.short_description ?? null,
    photo: data.value?.photo ?? null,
    icon: data.value?.icon ?? null,
    schemaType: 'website',
})));

</script>


<template>
  <SectionComponent v-if="data?.section" :section="data.section" />
</template>
